import { DeepPartial } from "@endya-conformite/ui-kit/src/lya/react-hook-form";
import { ParcoursAction } from "@src/parcours/NavigationButtons/ParcoursAction";
import { ParcoursFullPageTemplate } from "@src/parcours/Template/ParcoursFullPageTemplate";
import {
  ID_FORM_RENOUVELLEMENT,
  ParcoursRenouvellementStepComponentProps,
  RenouvellementStepEnum,
} from "@src/renouvellement/ParcoursRenouvellement.definition";
import {
  EntrepriseContactMediationForm,
  EntrepriseContactMediationFormValues,
} from "@src/societes/form/EntrepriseContactMediationForm";
import { useRenouvellementOffert } from "@src/renouvellement/useRenouvellementOffert";
import { useMe } from "@src/store/store.me";
import { merge } from "lodash";
import { useCallback } from "react";
import { RenouvellementData } from "../RenouvellementData";

export function RenouvellementContactMediationPage({
  data,
  setData,
  changeStep,
}: ParcoursRenouvellementStepComponentProps) {
  const { me } = useMe();
  const renouvellementOffert = useRenouvellementOffert();

  const handleSubmit = useCallback(
    (values: EntrepriseContactMediationFormValues) => {
      const updatedContactMediation = {
        nomMediation: values.nomMediation,
        prenomMediation: values.prenomMediation,
        civiliteMediation: values.civiliteMediation,
        mailMediation: values.mailMediation,
        telephoneMediation: values.telephoneMediation,
      };

      const updatedData: DeepPartial<RenouvellementData> = {
        resume: {
          contactMediation: updatedContactMediation,
        },
      };

      if (data.entreprisesAControler[data.resume.entreprisePrincipale.siren]) {
        updatedData.entreprisesAControler = {
          [data.resume.entreprisePrincipale.siren]: updatedContactMediation,
        };
      }

      setData(merge({}, data, updatedData));
      changeStep(
        renouvellementOffert
          ? RenouvellementStepEnum.RESUME_ENTREPRISE_RENOUVELLEMENT_OFFERT
          : RenouvellementStepEnum.RESUME_ENTREPRISE
      );
    },
    [setData, data, changeStep, renouvellementOffert]
  );

  if (!me) return <div />;
  return (
    <ParcoursFullPageTemplate
      title="Contact de médiation"
      actions={
        <ParcoursAction type="submit" formId={ID_FORM_RENOUVELLEMENT}>
          Enregistrer les modifications
        </ParcoursAction>
      }
    >
      <EntrepriseContactMediationForm
        formId={ID_FORM_RENOUVELLEMENT}
        defaultValues={{
          nomMediation: data.resume.contactMediation.nomMediation,
          prenomMediation: data.resume.contactMediation.prenomMediation,
          civiliteMediation: data.resume.contactMediation.civiliteMediation,
          mailMediation: data.resume.contactMediation.mailMediation,
          telephoneMediation: data.resume.contactMediation.telephoneMediation,
        }}
        onSubmit={handleSubmit}
      />
    </ParcoursFullPageTemplate>
  );
}
